export const rolesStringMapper = {
    OperationalTeam: 'Time operacional',
    ServiceTeam: 'Time de atendimento',
};
